/**
 * 语音播报Mixin
 */
export default {
    methods: {
        /**
         * 语音播报
         */
        speekTextFlush (text) {
            this.$bus.$emit('digital-human:standby');
            this.$bus.$emit('digital-human:speek-text', { text: text });
        },

        /**
         * 停止语音播报
         */
        speekTextStop () {
            this.$bus.$emit('digital-human:standby');
        }
    }
};
